import React from "react";
import ContentfulRichText from "../../utilities/contentful-rich-text";

import "./styles.css";

export const TakeAways = ({ text }) => {
  return (
    <div className="take-aways">
      <div className="take-aways-title">KEY TAKEAWAYS</div>
      <div className="take-aways-content">
        <ContentfulRichText
          raw={text}
        />
      </div>
    </div>
  );
};
